import React from "react";
import { createRoot } from "react-dom/client";
import { AdaptiveUi } from "@avinet/adaptive-ui-core";
import { gaia } from "./themes/gata";
import { App } from "./App";
import "./style/global.scss";
import "./style/utils.scss";
import "./style/map.scss";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <AdaptiveUi theme={gaia}>
      <App />
    </AdaptiveUi>
  </React.StrictMode>
);
